import { CloseOutlined } from "@ant-design/icons";
import { Avatar, Button, Card, Col, Form, Row, Space, Typography } from "antd";
import { useClientSearch } from "hook/clients/useClient";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { defaultClientInfoSelector } from "store/user/(default)/client/default_client.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const ClientInput = () => {
  // -------------------------- VAR -----------------------------
  const { handleRemoveClient } = useClientSearch();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const clientInfo = useSelector(defaultClientInfoSelector);
  const email = clientInfo?.email;
  const fullName = clientInfo?.fullName || email;
  const avatar = email?.slice(0, 2);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!clientInfo) return null;
  return (
    <Card size="small">
      <Row>
        <Col
          style={{
            display: "flex",
            alignItems: "center",
          }}
          xl={2}
          lg={2}
          md={4}
          xs={4}
        >
          <Avatar>{avatar}</Avatar>
        </Col>
        <Col xl={20} lg={20} md={18} xs={18}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography.Text style={{ color: "#555" }}>
              {fullName}
            </Typography.Text>
            <Typography.Text style={{ color: "#aeaeae" }}>
              {email}
            </Typography.Text>
          </div>
        </Col>
        <Col
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
          xl={2}
          lg={2}
          md={2}
          xs={2}
        >
          <Button
            onClick={handleRemoveClient}
            size="small"
            icon={<CloseOutlined />}
          />
        </Col>
      </Row>
    </Card>
  );
};
export default ClientInput;
